export default "__VITE_ASSET__Vo0b_E9X__"